import { inject, Injectable } from '@angular/core';
import { LoadingController, AnimationController } from '@ionic/angular';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private loading: HTMLIonLoadingElement;

  private readonly loadingCtrl = inject(LoadingController);
  private readonly animationCtrl = inject(AnimationController);

  public async present(message: string = null, spinner: boolean = true): Promise<void> {
    const createObj = {};

    if (message) {
      createObj['message'] = message;
    }
    if (spinner) {
      createObj['spinner'] = 'circles';
    } else {
      createObj['spinner'] = null;
      createObj['cssClass'] = 'ion-text-center';
    }

    createObj['translucent'] = true;
    createObj['backdropDismiss'] = false;
    createObj['color'] = 'primary';

    this.loading = await this.loadingCtrl.create(createObj);
    await this.loading.present();
  }

  public dismiss(): void {
    if (this.loading) {
      this.loading.leaveAnimation = (baseEl) =>
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        this.animationCtrl.create().addElement(baseEl).duration(150).fromTo('opacity', 1, 0);

      void this.loading.dismiss();
    }
  }
}
